export default __webpack_public_path__ + "static/media/gallery-wip-neck-rib_02.04b6f410.jpg";